import { render, staticRenderFns } from "./JsonTableItem.vue?vue&type=template&id=2dfdb8f1&"
import script from "./JsonTableItem.vue?vue&type=script&lang=ts&"
export * from "./JsonTableItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports